import { render, staticRenderFns } from "./PartnerRoleAndPermission.vue?vue&type=template&id=17a57352&scoped=true"
import script from "./PartnerRoleAndPermission.vue?vue&type=script&lang=js"
export * from "./PartnerRoleAndPermission.vue?vue&type=script&lang=js"
import style0 from "./PartnerRoleAndPermission.vue?vue&type=style&index=0&id=17a57352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a57352",
  null
  
)

export default component.exports